import React, { useEffect } from "react";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { DocumentScanner } from "@mui/icons-material";
import { useRef } from "react";
import 'jspdf-autotable';
import { formatSignatureDate } from "../../../utils/formatSignatureDate";
import { connect } from "react-redux";
import moment from "moment";
import { imageToBase64 } from "../../../utils/imageToBase64";
import { uploadCRMDocumentAndGetUrl } from "../../../utils/uploadDocument";
import { post } from "../../../api";

export const generatePDF = async (data, user, sasToken, isSendToTalentTrail = false, token, candidateId) => {
  const doc = new jsPDF();
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("New Starter Checklist", 105, 30, { align: "center" });

  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text("Personal Information", 105, 50, { align: "center" });

  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Industrial or Driving Work Wanted?", 10, 80);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(
    `${data?.industrialOrDrivingWork ? String(data?.industrialOrDrivingWork) : "--"}`,
    10,
    85
  );
  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Title", 10, 95);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(
    `${data?.title|| ""}`,
    10,
    100
  );

  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("First Name", 10, 110);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(
    `${data?.firstName || ""}`,
    10,
    115
  );

  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text(
    "Surname",
    10,
    125
  );
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(
    `${data?.surName || ""}`,
    10,
    130
  );

  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text(
    "Home Address",
    10,
    140
  );
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(
    `${data?.homeAddress || ""}`,
    10,
    145
  );

  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Postcode", 10, 155);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(
    `${data?.postCode || ""}`,
    10,
    160
  );

  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Mobile Number", 10, 170);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.mobile || ""}`, 10, 175);

  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Landline Number", 10, 185);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.landlineNumber || ""}`, 10, 190);
  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Email Address", 10, 200);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.email || ""}`, 10, 205);
  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("DOB", 10, 215);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.dateOfBirth || ""}`, 10, 220);


  const pageHeight = doc.internal.pageSize.height;
  const pageWidth = doc.internal.pageSize.width;
  const margin = 10;
  let currentHeight = margin;

  doc.addPage();

  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Are you male or female?", 10, 20);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.gender || ""}`, 10, 25);

  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("National Insurance Number", 10, 35);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.nationalInsuranceNumber || ""}`, 10, 40);

  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Criminal Convictions", 10, 50);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.criminalConviction || ""}`, 10, 55);

  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Please provide details of any criminal convictions, except any chich are 'spent' in accordance with the Rehabilitation pf offenders act 1974. If none please state none", 10, 65);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.criminalConvictionDetail || ""}`, 10, 70);

  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Do you hold a valid UK driving license (and Drive to work)", 10, 80);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.holdUkDrivingLicense || ""}`, 10, 85);

  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Can you report to work the same day we call you?", 10, 95);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.sameDayToReportWork || ""}`, 10, 100);

  //
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Do you have Safety Boots and Hi-Vis?", 10, 110);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.safetyBootOrH1 ? String(data?.safetyBootOrH1) : "--"}`, 10, 115);

  doc.addPage();

  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("Employee Statement", 105, 20, { align: "center" });

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("You have selected below empployment statement", 10, 50);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  if(data?.employeeStatement === "A") {
    doc.text(`A. This is my first job since last 6 April and I have not been receiving taxable Jobseeker’s Allowance, Employment and Support
Allowance, taxable Incapacity Benefit, State or Occupational Pension.`, 10, 60);
  }else if(data?.employeeStatement === "B") {
    doc.text(` B. This is now my only job but since last 6 April I have had another job, or received taxable Jobseeker’s Allowance, Employment
and Support Allowance or taxable Incapacity Benefit. I do not receive a State or Occupational Pension.`, 10, 60);
  } else if(data?.employeeStatement === "C") {
    doc.text(`C.As well as my new job, I have another job or receive a State or Occupational Pension.`, 10, 60);
  }

  doc.addPage();
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("Student Loan", 105, 20, { align: "center" });

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("2. Do you have a Student Loan which is not fully repaid?", 10, 40);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.haveStudentLoan}`, 10, 45);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Student Loan Plans", 10, 60);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("You will have a Plan 1 Student Loan if:", 10, 70);

  doc.setFont("helvetica", "normal");
  doc.text("- You lived in Scotland or Northern Ireland when you started your course, or", 10, 80);
  doc.text("- You lived in England or Wales and started your course before September 2012", 10, 85);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("You will have a Plan 2 Student Loan if:", 10, 95);

  doc.setFont("helvetica", "normal");
  doc.text("- You lived in England or Wales and started your course on or after 1 September 2012", 10, 105);


  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("3. What type of Student Loan do you have?", 10, 115);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.typeOfLoan}`, 10, 120);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("4. Did you finish your studies before the last 6 April?", 10, 130);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.finishStudies}`, 10, 135);


  doc.text("For further guidance about repaying Student Loans go to www.gov.uk/new-employee/student-loans", 10, 150);

  doc.addPage();

  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("Next Of Kin", 105, 20, { align: "center" });

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Name:", 10, 40);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.kinName}`, 10, 50);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Number:", 10, 60);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.kinNumber}`, 10, 70);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Relationship", 10, 80);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${data?.kinRelation}`, 10, 90);

  doc.addPage();

  currentHeight = 20;

  // Set bold text on the left
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Signable Form Title", margin, currentHeight); // Add bold text on the left
  doc.setFont("helvetica", "normal");
  doc.text("New Starter Checklist", pageWidth * 0.4, currentHeight); // Add the normal text 30% from the left

  currentHeight += 10;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Signable Form Provided by", margin, currentHeight); // Add bold text on the left
  doc.setFont("helvetica", "normal");
  doc.text("Rapid Resourcing", pageWidth * 0.4, currentHeight); // Add the normal text 30% from the left
  currentHeight += 10;

  doc.line(margin, currentHeight, pageWidth - margin, currentHeight); // Draw a horizontal line across the page
  currentHeight += 10; // Move down a little to make space for the paragraph
  // Add paragraph text after the line
  const paragraphText = `By signing this page, I confirm that I fully understand the content and agree to adhere to it at all times. I also agree that all the details provided in this document are accurate and complete to the best of my knowledge.`;

  // Use splitTextToSize to fit the paragraph within the page width
  const paragraphLines = doc.splitTextToSize(
    paragraphText,
    pageWidth - 2 * margin
  );

  // Add the paragraph to the document
  doc.setFontSize(10);
  doc.text(paragraphLines, margin, currentHeight); // Render paragraph
  currentHeight += 20;

  // Add paragraph text after the line
  const paragraphText2 = `By ticking this box I consent to the company processing my data and the evidence of this document being stored within their system for the purpose of work finding services.`;

  // Use splitTextToSize to fit the paragraph within the page width
  const paragraphLines2 = doc.splitTextToSize(
    paragraphText2,
    pageWidth - 2 * margin
  );

  // Add the paragraph to the document
  doc.text(paragraphLines2, margin, currentHeight); // Render paragraph
  currentHeight += 40;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Date Signed", margin, currentHeight); // Add bold text on the left
  doc.setFont("helvetica", "normal");
  doc.text(`${data?.signDate ? moment(data?.signDate).format("DD-MM-YYYY") : '--'}`, pageWidth * 0.4, currentHeight); // Add the normal text 30% from the left
  currentHeight += 10;

  // Add signature image from URL
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Signature", margin, currentHeight);

  // Add the signature image if the URL exists
  if (data?.signature) {
    try {
      const imgData = await imageToBase64(`${data.signature}?${sasToken}`);
      doc.addImage(imgData, "JPEG", pageWidth * 0.4, currentHeight, 30, 15);
    } catch (e) {
      console.error("Error loading signature image:", e);
    }
  }
  currentHeight += 20;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Name", margin, currentHeight); // Add bold text on the left
  doc.setFont("helvetica", "normal");
  doc.text(
    `${user?.firstName} ${user?.lastName}`,
    pageWidth * 0.4,
    currentHeight
  ); // Add the normal text 30% from the left
  currentHeight += 10;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("IP Address", margin, currentHeight); // Add bold text on the left
  doc.setFont("helvetica", "normal");
  doc.text(`${data?.ipAddress}`, pageWidth * 0.4, currentHeight); // Add the normal text 30% from the left
  currentHeight += 10;

  // Save the PDF
  // Save the PDF
  if (isSendToTalentTrail) {
    const pdfBlob = doc.output("blob");
    const formData = new FormData();
    formData.append(
      "file",
      pdfBlob,
      `new-starter-checklist-${user?.firstName}-${user?.lastName}.pdf`
    );
    formData.append("candidateId", candidateId);
    const documentUrl =
      (await uploadCRMDocumentAndGetUrl(formData, token)) || "";
    console.log("documentUrl", documentUrl);
    if (documentUrl) {
      const payload = {
        candidateId,
        fileName: `new-starter-checklist-${user?.firstName}-${user?.lastName}.pdf`,
        fileExtention: ".pdf",
        fileType: "workExperience",
        fileLink: documentUrl,
        licenseNo: "rapidresourcing",
      };

      const url = "/api/candidate/save-document";
      try {
        const res2 = await post(url, payload);
        console.log("Document saved successfully:", res2.data);
      } catch (error) {
        console.error("Error saving document:", error);
      }
    } else {
      console.error("Failed to upload document, skipping save.");
    }
  } else {
    doc.save(`new-starter-checklist-${user?.firstName}-${user?.lastName}.pdf`);
  }
};
const NewStarterChecklistDownload = ({ data, sasToken, user }) => {
  const signatureRef = useRef(null); // Create a reference to the image element
  useEffect(() => {
    if (signatureRef.current) {
      // Set the crossOrigin attribute to allow cross-origin image loading
      signatureRef.current.crossOrigin = 'anonymous';
    }
  }, []);
  
  return (
    <>
      <div className="text-center p-4 document-sign">
        <p>{formatSignatureDate(data?.signDate, user)}</p>
        <div>
          {data?.signature && <img
            ref={signatureRef}
            src={`${data?.signature}?${sasToken}`}
          />}
          
        </div>
      </div>
      <div className="text-center w-100 mt-4">
        <button className="btn btn-success btn-lg" onClick={() => generatePDF(data, user, sasToken)}>
          <DocumentScanner /> Download your receipt
        </button>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({});
export default connect(
  mapStateToProps,
  {}
)(NewStarterChecklistDownload);

